import React, { useEffect, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CCard, CCardBody, CCardHeader, CCol, CRow, CFormCheck, CNav, CNavItem, CNavLink } from '@coreui/react';


// Вкладка "Ціна"
const ProductPrice = (props) => {
    // console.log('ProductPrice props', props);

    //Прайс-тепер результуюче значення.Показує або sallePrice або normalPrice в залежності акція або ні
    const [oldPrice, setOldPrice] = useState(props?.MyData?.oldPrice ?? 0);
    const [sallePrice, setSallePrice] = useState(props?.MyData?.sallePrice ?? 0); // Акційна ціна
    //нормальна ціна-аналог price який був раніше
    // const [normalPrice, setNormalPrice] = useState(props?.MyData?.normalPrice ?? 0)
    const [normalPrice, setNormalPrice] = useState(props?.MyData?.normalPrice ?? props?.MyData?.price)
    const [isFreeShipping, setIsFreeShipping] = useState(props?.MyData?.isFreeShipping ?? false); // Безкоштовна доставка
    const [isDisabledBtnSubmit, setIsDisabledBtnSubmit] = useState(true);
    const [isSalle, setIsSalle] = useState(false);
    const serverIsSalle = !!props?.MyData?.isSalle; // Серверне значення для чекбокас "Акція"
    const isSalleChanged = isSalle !== serverIsSalle; // Чи змінився чекбокс для "Акція" відносно серверного значення

    const [categoryIris, setCategoryIris] = useState([]); // Масив категорій в форматі IRI (рядки типу "/api/categories/123") для оновлення в товарі

    // Заповнити значення для чекбокса "Акція" при оновленні даних товару
    useEffect(() => {
        setIsSalle(!!props?.MyData?.isSalle);
    }, [props?.MyData?.isSalle]);

    const actualPrice =
        // props.isSalle
        isSalle
            ? Number(sallePrice)
            : Number(normalPrice);

    const normalizeNumber = (value) =>
        value === null || value === undefined ? 0 : Number(value);

    const data_response = {
        price: actualPrice,
        normalPrice: Number(normalPrice),
        oldPrice: Number(oldPrice),
        sallePrice: Number(sallePrice),
        isSalle: isSalle,
        isFreeShipping: isFreeShipping,
        ... (isSalleChanged ? { category: categoryIris } : {}),
        active: 'on',
    };

    // Оновлення цін при оновленні пропсів
    useEffect(() => {
        if (props.MyData) {
            if (props.MyData?.oldPrice || props.MyData?.oldPrice === 0) {
                setOldPrice(props.MyData.oldPrice)
            }
            if (props.MyData?.sallePrice || props.MyData?.sallePrice === 0) {
                setSallePrice(props.MyData.sallePrice)
            }
            if (props.MyData?.normalPrice || props.MyData?.normalPrice === 0) {
                setNormalPrice(props.MyData.normalPrice)
            }
        }
    }, [props.MyData]);

    // Функція для оновлення даних
    const submitData = (event) => {
        setIsDisabledBtnSubmit(true);
        props.handleSubmit(
            event,
            data_response);
    };

    // // Відслідковувати блокування кнопки оновлення даних
    useEffect(() => {
        if (!props.MyData) return;
        const salle = props?.MyData?.sallePrice ?? 0;
        if (
            normalizeNumber(props?.MyData?.normalPrice) == normalizeNumber(normalPrice) &&
            normalizeNumber(props?.MyData?.sallePrice) === normalizeNumber(sallePrice) &&
            normalizeNumber(props.MyData.oldPrice) == normalizeNumber(oldPrice) &&
            !isSalleChanged &&
            props.MyData.isFreeShipping === isFreeShipping) {
            setIsDisabledBtnSubmit(true);
        } else {
            setIsDisabledBtnSubmit(false);
        };
    }, [props.MyData, oldPrice, isFreeShipping, sallePrice, normalPrice, isSalleChanged])

    // Розрахувати finallArr тільки коли потрібно (коли змінився isSalle відносно сервера)
    useEffect(() => {
        const categoryIdsFromServer = props?.MyData?.category?.map((elem) => elem.id) ?? [];

        // Якщо salleCategoryId ще не прийшов — НЕ намагаємось додавати/видаляти "Новинки"
        // (categoryIris може бути оновлений базовими категоріями)
        if (!props?.salleCategoryId) {
            setCategoryIris(categoryIdsFromServer.map((id) => `/api/categories/${id}`));
            return;
        };

        // Якщо чекбокс не змінився - finallArr можна залишити як є з сервера
        if (!isSalleChanged) {
            setCategoryIris(categoryIdsFromServer.map((id) => `/api/categories/${id}`));
            return;
        };

        const salleId = props.salleCategoryId;
        let ids = categoryIdsFromServer;

        // UI: true, сурвер: false -> додати категорію Новинки
        if (isSalle && !serverIsSalle) {
            if (!ids.includes(salleId)) ids = [...ids, salleId];
        };

        // UI: false, сурвер: true -> додати категорію Новинки
        if (!isSalle && serverIsSalle) {
            ids = ids.filter((id) => id !== salleId);
        };

        setCategoryIris(ids.map((id) => `/api/categories/${id}`));
    }, [props?.MyData?.category, props?.salleCategoryId, isSalle, serverIsSalle, isSalleChanged]);

    // //перевірка валідності поля ціни і акційної ціни
    const isFormValid = () => {
        if (isSalle) {
            return Number(sallePrice) > 0;
        };
        return Number(normalPrice) > 0;
    };


    return (
        <div>
            <CForm>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput11" label="Безкоштовна доставка" checked={isFreeShipping} onChange={() => setIsFreeShipping(!isFreeShipping)} />
                </div>
                <div className="mb-3">
                    <CFormCheck id="exampleFormControlInput113" label="Акція" checked={isSalle} onChange={() => setIsSalle(prev => !prev)} />
                </div>
                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Попередня ціна</CFormLabel>
                    <CFormInput type="number" id="exampleFormControlInput7" value={oldPrice == null ? 0 : oldPrice}
                        onChange={(e) => setOldPrice(e.target.value)} required
                    />
                </div>
                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Акційна ціна</CFormLabel>
                    <CFormInput
                        type="number" id="exampleFormControlInput8" value={sallePrice} onChange={(e) => setSallePrice(e.target.value)} autoComplete="off" required />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Звичайна ціна</CFormLabel>
                    <CFormInput
                        type="number" id="exampleFormControlInput9" value={normalPrice} onChange={(e) => setNormalPrice(e.target.value)} autoComplete="off" required />
                </div>
                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Актуальна ціна</CFormLabel>
                    <CFormInput disabled type="number" id="exampleFormControlInput6"
                        value={props?.MyData?.price}
                        autoComplete="off" />
                </div>
                <CButton color="success" onClick={(event) => submitData(event)} disabled={isDisabledBtnSubmit || !isFormValid()}>Зберегти</CButton>
            </CForm>
        </div>
    );
};

export default ProductPrice;